import React from 'react'
import CheckBoxFilter from '../../../CheckBoxFilter'
import { RU_LOCALE } from '../../constants/constants'
import { PresetsProps, PresetType } from '../../types'
import { StyledPresets } from './Presets.styles'

/**
 * Компонент пресетов для быстрого выбора периодов
 * Отображает кнопки: Сегодня, Вчера, Неделя, Месяц, Год
 */
const Presets: React.FC<PresetsProps> = ({
	activePreset,
	availablePresets,
	onSelectPreset,
	disabled = false,
}) => {
	const getPresetLabel = (preset: PresetType): string => {
		const labels: Record<PresetType, string> = {
			today: RU_LOCALE.LABELS.TODAY,
			yesterday: RU_LOCALE.LABELS.YESTERDAY,
			week: RU_LOCALE.LABELS.WEEK,
			month: RU_LOCALE.LABELS.MONTH,
			year: RU_LOCALE.LABELS.YEAR,
		}
		return labels[preset]
	}

	return (
		<StyledPresets>
			{availablePresets.map(preset => (
				<CheckBoxFilter
					key={preset}
					title={getPresetLabel(preset)}
					active={activePreset === preset}
					onClick={() => onSelectPreset(preset)}
					disabled={disabled}
				/>
			))}
		</StyledPresets>
	)
}

export default Presets
